import React from 'react'
import './index.less'

interface Props {
  labelInfo: {
    activityType: number // 0-原始价格，1-车主专享价，2-场站活动价，3-渠道接出价
    activityAbbr: string
    activityAbbr2: string // showInFeeModal=true时价格详情弹窗使用该文案
    activityPriceDesc: string
    activityPriceDesc2: string // showInFeeModal=true时价格详情弹窗使用该文案
  }
  showInFeeModal?: boolean // 若在价格详情弹窗，需要显示不同的文案
  className?: string
  disabled?: boolean
  showBackUpText?: boolean
}

const PriceLabel = (props: Props) => {
  const {
    labelInfo,
    showInFeeModal = false,
    className,
    disabled = false,
    showBackUpText = true
  } = props
  const {
    activityAbbr,
    activityAbbr2,
    activityPriceDesc,
    activityPriceDesc2,
    activityType
  } = labelInfo || {}

  if (!activityAbbr && !activityAbbr2) {
    return showBackUpText ? <div className={`default-price-label-wrap ${className || ''}`}>预估单价</div> : null
  }

  const renderLabel = () => {
    switch (activityType) {
      case 0:
        return <>
          {
            showInFeeModal ?
            <div className={`price-label-wrap ${className || ''}`}>
              <div className={`vip-guide-tip ${disabled ? 'disabled' : ''}`}>{activityAbbr2}{activityPriceDesc2}</div>
            </div>
            :
            <div className={`price-label-wrap ${className || ''}`}>
              <div className={`vip-guide-tip ${disabled ? 'disabled' : ''}`}>{activityAbbr}</div>
              <div className={`vip-guide-price ${disabled ? 'disabled' : ''}`}>{activityPriceDesc}</div>
            </div>
          }
        </>
      case 1:
        return <>
          {
            showInFeeModal ?
            <div className={`price-label-wrap ${className || ''}`}>
              <div className={`vip-guide-tip ${disabled ? 'disabled' : ''}`}>{activityAbbr2}</div>
            </div>
            :
            <div className={`price-label-wrap ${className || ''}`}>
              <div className={`vip-price-tag ${disabled ? 'disabled' : ''}`}>{activityAbbr}</div>
            </div>
          }
        </>
      case 2:
        return <>
          {
            showInFeeModal ?
            <div className={`price-label-wrap ${className || ''}`}>
              <div className='activity-tag-in-fee'>{activityAbbr2}</div>
            </div>
            :
            <div className={`price-label-wrap ${className || ''}`}>
              <div className={`activity-tag ${disabled ? 'disabled' : ''}`}>{activityAbbr}</div>
            </div>
          }
        </>
      default:
        return null
    }
  }

  return renderLabel()
}

export default PriceLabel;